import { render, staticRenderFns } from "./ProvidingBankStatementTab.vue?vue&type=template&id=38b20df4&scoped=true"
import script from "./ProvidingBankStatementTab.vue?vue&type=script&lang=js"
export * from "./ProvidingBankStatementTab.vue?vue&type=script&lang=js"
import style0 from "./ProvidingBankStatementTab.vue?vue&type=style&index=0&id=38b20df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b20df4",
  null
  
)

export default component.exports